import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/auth.store";

export const ProtectedRoutes = () => {
  const { authUser: user } = useAuthStore();

  // if (isLoading) {
  //   return <div>Loading...</div>; // Or your loading component
  // }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
